import React, { useRef } from 'react';
import { CloudArrowUp, X, ImageSquare } from '@phosphor-icons/react';
import { cn } from '../../lib/utils';
const ACCEPTED = ['image/jpeg', 'image/png', 'image/webp', 'image/avif'];
const MAX_PHOTOS = 10;
interface StepPhotosProps {
  photos: string[];
  onChange: (photos: string[]) => void;
}
export function StepPhotos({
  photos,
  onChange
}: StepPhotosProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleFiles = (files: FileList | null) => {
    if (!files) return;
    const remaining = MAX_PHOTOS - photos.length;
    const list = Array.from(files).slice(0, remaining);
    list.forEach(file => {
      if (!ACCEPTED.includes(file.type)) return;
      const reader = new FileReader();
      reader.onload = e => {
        const url = e.target?.result as string;
        onChange([...photos, url]);
      };
      reader.readAsDataURL(file);
    });
  };
  const removeAt = (idx: number) => {
    onChange(photos.filter((_, i) => i !== idx));
  };
  return <div className="animate-in fade-in slide-in-from-bottom-2 duration-300 space-y-6" data-id="element-2690">
      <div data-id="element-2691">
        <h2 className="text-2xl sm:text-3xl font-bold text-light-1 mb-2" data-id="element-2692">
          Fotografii{' '}
          <span className="text-light-4 text-base font-normal" data-id="element-2693">(opțional)</span>
        </h2>
        <p className="text-sm text-light-3" data-id="element-2694">
          Adaugă poze clare ca să atragi chiriași. Maxim {MAX_PHOTOS} poze.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3" data-id="element-2695">
        {photos.map((src, i) => <div key={i} className="relative aspect-square rounded-xl overflow-hidden bg-dark-3 border border-dark-4 group" data-id="element-2696">
            <img src={src} alt={`Poza ${i + 1}`} className="w-full h-full object-cover" data-id="element-2697" />
            <button type="button" onClick={() => removeAt(i)} className="absolute top-2 right-2 w-7 h-7 rounded-full bg-dark-1/80 text-light-1 inline-flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-1" aria-label="Elimină poza" data-id="element-2698">
              <X size={14} weight="bold" data-id="element-2699" />
            </button>
            {i === 0 && <span className="absolute bottom-2 left-2 px-2 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wider bg-lime-1 text-dark-1" data-id="element-2700">
                Copertă
              </span>}
          </div>)}

        {photos.length < MAX_PHOTOS && <button type="button" onClick={() => inputRef.current?.click()} className={cn('aspect-square rounded-xl border-2 border-dashed border-dark-4 hover:border-lime-1 hover:bg-dark-2 transition-colors', 'flex flex-col items-center justify-center gap-2 text-light-3 hover:text-light-1 cursor-pointer')} data-id="element-2701">
            {photos.length === 0 ? <>
                <CloudArrowUp size={32} weight="regular" data-id="element-2702" />
                <span className="text-xs font-medium" data-id="element-2703">Adaugă poze</span>
              </> : <>
                <ImageSquare size={24} weight="regular" data-id="element-2704" />
                <span className="text-xs font-medium" data-id="element-2705">+ Adaugă</span>
              </>}
          </button>}
      </div>

      <input ref={inputRef} type="file" accept={ACCEPTED.join(',')} multiple onChange={e => handleFiles(e.target.files)} className="hidden" data-id="element-2706" />

      <p className="text-xs text-light-4" data-id="element-2707">
        JPEG, PNG, WebP sau AVIF · max 10MB per poză. Prima poză devine coperta.
      </p>
    </div>;
}